document.addEventListener("DOMContentLoaded", initCards);
document.addEventListener("htmx:afterSwap", initCards);

const target = Symbol();
const persist = Symbol();

function initCards() {
  const cards = document.querySelectorAll(".card-tilt");
  cards.forEach((card) => {
    const item = card.parentElement;

    setProps(card, { x: 0.0, y: 0.0, shine: 1.0 });
    card[target] = { x: 0.0, y: 0.0, shine: 1.0 };

    // @ts-ignore It's not the root element so it has a parent
    item.addEventListener("pointerenter", startHover);
    // @ts-ignore
    item.addEventListener("pointerleave", endHover);
  });
}

function startHover(e: PointerEvent) {
  const item = e.currentTarget as HTMLElement;
  const card = item.firstElementChild;

  processHover(e);
  transition(card);
  card[persist] = true;

  // @ts-ignore TS doesn't recognise that this is the correct event handler
  item?.addEventListener("pointermove", processHover);
}

function processHover(e: PointerEvent) {
  const item = e.currentTarget as HTMLElement;
  const card = item.firstElementChild;

  const tiltMax = 1.5;
  const shineChange = 0.05;

  const width = item.offsetWidth;
  const height = item.offsetHeight;

  const left = item.offsetLeft;
  const top = item.offsetTop;

  const cardCenter = [left + width / 2, top + height / 2];

  const relativePos = [e.pageX - cardCenter[0], e.pageY - cardCenter[1]];

  const props = {
    x: tiltMax * -1 * (relativePos[1] / (height / 2)),
    y: tiltMax * (relativePos[0] / (width / 2)),
    shine: 1 - shineChange * (relativePos[1] / (height / 2)),
  };

  card[target] = props;
}

function endHover(e: PointerEvent) {
  const item = e.currentTarget as HTMLElement;
  // @ts-ignore TS doesn't recognise that this is the correct event handler
  item.removeEventListener("pointermove", processHover);
  const card = item.firstElementChild;

  card[target] = { x: 0.0, y: 0.0, shine: 1.0 };
  card[persist] = false;
}

function transition(card: HTMLElement) {
  if (isClose(card) && !card[persist]) return;

  const props = getProps(card);
  const factor = -0.08;

  setProps(card, {
    x: props.x + (card[target].x - props.x) * (1.0 - Math.exp(factor)),
    y: props.y + (card[target].y - props.y) * (1.0 - Math.exp(factor)),
    shine:
      props.shine +
      (card[target].shine - props.shine) * (1.0 - Math.exp(factor)),
  });

  requestAnimationFrame(() => {
    transition(card);
  });
}

function getProps(card: HTMLElement) {
  return {
    x: Number(card.style.getPropertyValue("--rotx").split("deg")[0]),
    y: Number(card.style.getPropertyValue("--roty").split("deg")[0]),
    shine: Number(card.style.getPropertyValue("--bright")),
  };
}

function setProps(
  card: HTMLElement,
  props: { x: number; y: number; shine: number },
) {
  card.style.setProperty("--rotx", `${props.x}deg`);
  card.style.setProperty("--roty", `${props.y}deg`);
  card.style.setProperty("--bright", props.shine);
}

function isClose(card) {
  const props = getProps(card);

  return (
    props.x + 0.25 > card[target].x &&
    props.x - 0.25 < card[target].x &&
    props.y + 0.25 > card[target].y &&
    props.y - 0.25 < card[target].y &&
    props.shine + 0.01 > card[target].shine &&
    props.shine - 0.01 < card[target].shine
  );
}
